import * as React from 'react'
import { useIntl } from 'react-intl'
import Modal from 'LuxKit/Modal/Modal'
import HelpPane from 'components/Common/HelpPane'
import BodyText from 'LuxKit/Typography/BodyText'
import CancellationPolicyTimeline from 'components/Common/CancellationPolicies/CancellationPolicyTimeline'
import cancellationPolicyTimelineMessages from 'components/Common/CancellationPolicies/cancellationPolicyTimelineMessages'

interface Props {
  /** Modal title when the policy is listed rather than shown as a timeline. */
  heading: string
  isOpen?: boolean
  onClose?: (e: React.MouseEvent<HTMLButtonElement>) => void
  policyDescriptions: Array<string | undefined>
  /** The free-cancellation deadline the rate's label shows; set only when the policy reads as a timeline. */
  timelineDeadline?: string
  descriptionVariant?: 'large' | 'medium'
}

function CancellationPolicyModal(props: Props) {
  const { heading, isOpen, onClose, policyDescriptions, timelineDeadline, descriptionVariant = 'large' } = props
  const intl = useIntl()

  return <Modal
    title={timelineDeadline ? intl.formatMessage(cancellationPolicyTimelineMessages.modalTitle) : heading}
    isOpen={isOpen}
    onClose={onClose}
  >
    {timelineDeadline
      ? <CancellationPolicyTimeline deadline={timelineDeadline} policyDescriptions={policyDescriptions} />
      : policyDescriptions.map((line, index) => <BodyText variant={descriptionVariant} as="p" key={index}>{line}</BodyText>)}
    <HelpPane />
  </Modal>
}

export default CancellationPolicyModal
